import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import { signUp } from "@/lib/auth";
import { supabase } from "@/lib/supabase";

interface SignupFormProps {
  onSwitchToLogin: () => void;
}

export function SignupForm({ onSwitchToLogin }: SignupFormProps) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      toast.error("Le password non coincidono");
      return;
    }

    if (password.length < 6) {
      toast.error("La password deve avere almeno 6 caratteri");
      return;
    }

    setLoading(true);

    const { data, error } = await signUp(email, password);

    if (error) {
      setLoading(false);
      toast.error(error.message);
      return;
    }

    if (data.user) {
      // Initialize wallet for new user
      const { error: walletError } = await supabase.from("wallets").insert([
        {
          user_id: data.user.id,
          crypto: "USD",
          amount: 10000, // Demo balance
        },
      ]);

      if (walletError) {
        console.error("Wallet creation error:", walletError);
      }
    }

    setLoading(false);
    toast.success("Account creato! Accedi per continuare.");
    onSwitchToLogin();
  };

  return (
    <Card className="w-full max-w-md p-8">
      <h1 className="text-2xl font-bold mb-6">Iscriviti</h1>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <Label htmlFor="email">Email</Label>
          <Input
            id="email"
            type="email"
            placeholder="your@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div>
          <Label htmlFor="password">Password</Label>
          <Input
            id="password"
            type="password"
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <div>
          <Label htmlFor="confirmPassword">Conferma Password</Label>
          <Input
            id="confirmPassword"
            type="password"
            placeholder="••••••••"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </div>
        <Button type="submit" className="w-full" disabled={loading}>
          {loading ? "Creazione account..." : "Iscriviti"}
        </Button>
      </form>
      <p className="text-center text-sm text-primary/60 mt-4">
        Hai già un account?{" "}
        <button
          onClick={onSwitchToLogin}
          className="text-primary hover:underline font-medium"
        >
          Accedi
        </button>
      </p>
    </Card>
  );
}
